module.exports = __webpack_public_path__ + "img/target_cashback.4bd40c07.svg";